module.exports = __webpack_public_path__ + "img/olive.bca05ce0.png";